import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-error',
    templateUrl: './app.error.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppErrorComponent {

}
